import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  background: #fafafa;

  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 24px;

  display: inline-flex;
  flex-wrap: wrap;
  gap: 16px;
`;


export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 24px;
  color: ${({ theme }) => theme.colors.orange.primary};
  background: transparent;
  border: none;
  text-decoration: underline;
  transition: opacity 0.2s;
  svg {
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.orange.primary};
    border-radius: 50%;
    margin-right: 6px;
  }

  &:hover {
    opacity: 0.8;
  }
`;
